<template>
  <div style="position: relative;">
    <div v-if="!iframeLoaded && iframeConfig.src" class="preloadFilter">
      <Loading />
    </div>
    <IFrameResizer
      v-if="iframeConfig.src"
      v-show="iframeLoaded"
      :config="iframeConfig"
      class="careerIFrame"
      @loaded="iframeLoaded = true"
    />
  </div>
</template>

<script>
import IFrameResizer from "../IFrameResizer/IFrameResizer";
import Loading from "../Loading/Loading";

export default {
  name: "CareerIFrame",
  components: {
    IFrameResizer,
    Loading
  },
  props: {
    config: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      iframeTrigger: null,
      careerDetailContainer: null,
      careerIframeContainer: null,
      iframeLoaded: false,
      iframeConfig: {
        id: "erecruitframe",
        width: "100%",
        height: "1025px",
        src: null
      },
      eRecruitdomainHttp: "http://wika-portal.rexx-recruitment.com",
      eRecruitdomainHttps: "https://wika-portal.rexx-recruitment.com"
    };
  },
  methods: {
    receiveMessage(event) {
      if (
        event.origin !== this.eRecruitdomainHttp ||
        event.origin !== this.eRecruitdomainHttps
      ) {
        return;
      }
      if (event.data === "close") {
        this.careerDetailContainer.classList.remove("inactive");
        this.careerIframeContainer.classList.add("inactive");
      }
    }
  },
  mounted() {
    window.addEventListener("message", this.receiveMessage, false);
    this.iframeTrigger = document.querySelector(".Button__apply");
    this.careerIframeContainer = document.querySelector(
      ".CareerIFrame__container"
    );
    this.careerDetailContainer = document.querySelector(
      ".CareerDetail__container"
    );
    this.iframeTrigger.addEventListener("click", event => {
      event.preventDefault();
      this.careerDetailContainer.classList.add("inactive");
      this.careerIframeContainer.classList.remove("inactive");
    });
    this.iframeConfig.src = this.config.src;
  }
};
</script>

<style module lang="scss">
@import "./CareerIFrame.scss";
</style>
